<div class="main-box" fxLayout="row">
    <div fxFlex="25" class="sub-box left-box-flex" fxLayout="row">
        <img src="assets/entry-point.svg">
        <span class="left-nav-text">Chat Page banner</span>
    </div>
    <div fxFlex="75" class="sub-box">
        <div class="grey-heading-container">
            <span class="text">Chat Page Banner</span>
            <button class="create-button" routerLink="/admin/banners/create-banner/new">
                <div class="text">
                    <img src="assets/plus-icon.svg">
                    Create New
                </div>
            </button>
        </div>
        <div style="padding: 15px;">
            <div fxLayout="row" style="gap: 10px;">
                <div class="search-bar">
                    <mat-icon [ngStyle]="{'color':'#386AF6'}" matSuffix>search</mat-icon>
                    <input style="border: none;outline: none;" matInput placeholder="Search" (input)="searchBannerByInput()" [(ngModel)]="searchValue">
                </div>
                <div ngbDropdown>
                    <button type="button" class="btn selectpicker" id="dropdownBasic1" ngbDropdownToggle
                        style="flex-direction: row;padding:9px">
                        <div fxLayout="column" style="margin-right: 25px;">
                            <span *ngIf="filterStatus=='allBanner'" class="dropdown-text">Filter by Status</span>
                            <span  *ngIf="filterStatus!='allBanner'" class="dropdown-text">{{filterStatus}}</span>
                        </div>
                        <mat-icon style="margin-left: 5%;color: #386AF6;"
                            fxLayoutAlign="end">keyboard_arrow_down</mat-icon>
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" style="overflow: auto;max-height: 40vh;"
                        class="custom_scrollbar">
                        <button ngbDropdownItem style="font-size: 12px;" class="py-2" (click)="shortAccToStatus('allBanner')">
                            All
                        </button>
                        <button ngbDropdownItem style="font-size: 12px;" class="py-2" (click)="shortAccToStatus('Active')">
                            Active
                        </button>
                        <button ngbDropdownItem style="font-size: 12px;" class="py-2" (click)="shortAccToStatus('Inactive')">
                            InActive
                        </button>
                    </div>
                </div>
            </div>
            <div fxLayout="row" fxLayoutAlign="space-between center" style="margin-top: 10px;">
                <div fxFlex="26%">
                    <span class="table-header-text">Title</span>
                </div>
                <div fxFlex="14%" class="text-center">
                    <span class="table-header-text">Start Date</span>
                    <img class="arrow-icon">
                </div>
                <div fxFlex="24%" class="text-center">
                    <span class="table-header-text">Timings</span>
                    <img class="arrow-icon">
                </div>
                <div fxFlex="14%" class="text-center">
                    <span class="table-header-text">Frequency</span>
                    <img class="arrow-icon">
                </div>
                <div fxFlex="13%" class="text-center">
                    <span class="table-header-text">Status</span>
                    <img class="arrow-icon">
                </div>
                <div fxFlex="5%" >

                </div>
            </div>
            <div *ngFor="let banner of allBannerList; let i=index;" class="table-item">
                <div fxLayout="row" fxLayoutAlign="space-between center table-text-item">
                    <div fxFlex="27%" class="table-text-item" style="padding-left: 5px;">
                        {{banner?.name}}
                    </div>
                    <div fxFlex="15%" class="text-center table-text-item">
                        {{banner?.start_date | dateTransform: 'std' }}
                    </div>
                    <div fxFlex="25%" class="text-center table-text-item">
                        {{banner?.start_time | dateTransform: 'convertFrom24To12Format'}}-{{banner?.end_time | dateTransform: 'convertFrom24To12Format'}}
                    </div>
                    <div fxFlex="15%" class="text-center table-text-item">
                        Daily
                    </div>
                    <div fxFlex="14%" class="text-center table-text-item">
                        <button [matMenuTriggerFor]="menu"
                            style="border: 1px white; background-color: white; border-radius: 5px; align-items: center;"
                            fxLayout="row">
                            <img *ngIf="banner?.status==='ACTIVE'" src="assets/active-icon.svg">
                            <span *ngIf="banner?.status==='ACTIVE'"
                                style="color: #00BA34; font-size: 14px; font-family: Montserrat; font-weight: 700; letter-spacing: 1.12px; word-wrap: break-word">ACTIVE</span>
                            <span *ngIf="banner?.status==='INACTIVE'"
                                style="color: black; font-size: 14px; font-family: Montserrat; font-weight: 700; letter-spacing: 1.12px; word-wrap: break-word">INACTIVE</span>
                            <mat-icon style="margin-left: 5%;color: #386AF6;"
                                fxLayoutAlign="end">keyboard_arrow_down</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="triggerChangeStatus('ACTIVE', banner.id)">
                                <span>Active</span>
                            </button>
                            <button mat-menu-item (click)="triggerChangeStatus('INACTIVE', banner.id)">
                                <span>Inactive</span>
                            </button>
                        </mat-menu>
                    </div>
                    <div fxFlex="5%" class="text-center">
                        <mat-icon style="color: #386AF6; cursor: pointer;" routerLink="/admin/banners/create-banner/{{banner.id}}">mode_edit</mat-icon>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>